// Initialize Foundation
jQuery(document).foundation();


/*function getHashFilter() {
	var hash = location.hash;
	// get filter=filterName
	var matches = location.hash.match( /filter=([^&]+)/i );
	var hashFilter = matches && matches[1];
	return hashFilter && decodeURIComponent( hashFilter );
}*/

// Run when DOM is ready
(function($) {
	
	// Flickity carousel on home page
	var $carousel = $('#home-carousel').flickity({
		cellAlign: 'left',
		contain: true,
		pageDots: false,
		wrapAround: true,
		percentPosition: true,
		autoPlay: 5000,
		imagesLoaded: true
	});
	/*var $imgs = $carousel.find('.carousel-cell img');
	// get transform property
	var docStyle = document.documentElement.style;
	var transformProp = typeof docStyle.transform == 'string' ?
	  'transform' : 'WebkitTransform';
	// get Flickity instance
	var flkty = $carousel.data('flickity');*/
	
	// This stuff does a parallax effect
	/*var $imgs = $carousel.find('.carousel-cell .cell-background');
	var flkty = $carousel.data('flickity');

	$carousel.on( 'scroll.flickity', function() {
	  flkty.slides.forEach( function( slide, i ) {
	    var img = $imgs[i];
	    var x = ( slide.target + flkty.x ) * -1/3;
	    img.style.backgroundPosition = x + 'px center';
	  });
	});*/
	
	
	
	
	
	// Isotope / packery for Team page
	/*var $teamgrid = $('#team-list').isotope({
		itemSelector: '.cell',
		//layoutMode: 'masonry',
		masonry: {
			//gutter:'.gutter-sizer',
			columnWidth: '.grid-sizer'
		},
		percentPosition: true
	});*/
	$('#team-list').packery({
	  // options
	  itemSelector: 'li.cell',
	  //gutter: 10
	});
  	
  	
  	// Isotope and filtering on Projects page
  	var $jobgrid = $('.openings-list').isotope({
		itemSelector: '.openings-item',
		layoutMode: 'packery',
		packery: {
			//gutter:'.gutter-sizer',
			//columnWidth: '.grid-sizer'
		},
		percentPosition: true
	});
	// bind filter button click
	$('.filters-list').on( 'click', 'a', function() {
		var filterValue = $( this ).attr('data-filter');
		// use filterFn if matches value
		$jobgrid.isotope({ filter: filterValue });
	});
	// change is-checked class on buttons
	$('.filters-list').each( function( i, buttonGroup ) {
		var $buttonGroup = $( buttonGroup );
		$buttonGroup.on( 'click', 'a', function() {
			$buttonGroup.find('.is-active').removeClass('is-active');
			$( this ).parent('li').addClass('is-active');
  		});
	});
	
	
	
	// Isotope and filtering on Projects page
  	var $projectgrid = $('#archive-body .project-list').isotope({
		itemSelector: '.cell',
		layoutMode: 'packery',
		packery: {
			//gutter:'.gutter-sizer',
			//columnWidth: '.grid-sizer'
		},
		percentPosition: true
	});
	// store filter for each group
	var filters = {};
	
	$('.filters').on( 'click', 'a.filter', function( event ) {
	  var $button = $( event.currentTarget );
	  // get group key
	  var $buttonGroup = $button.parents('.filters-list');
	  var filterGroup = $buttonGroup.attr('data-filter-group');
	  // set filter for group
	  filters[ filterGroup ] = $button.attr('data-filter');
	  // combine filters
	  var filterValue = concatValues( filters );
	  // set filter for Isotope
	  $projectgrid.isotope({ filter: filterValue });
	});
	
	// change is-checked class on buttons
	$('.filters-list').each( function( i, buttonGroup ) {
	  var $buttonGroup = $( buttonGroup );
	  $buttonGroup.on( 'click', 'a.filter', function( event ) {
	    $buttonGroup.find('a.filter.is-active').removeClass('is-active');
	    var $button = $( event.currentTarget );
	    $button.addClass('is-active');
	  });
	});
	  
	// flatten object by concatting values
	function concatValues( obj ) {
	  var value = '';
	  for ( var prop in obj ) {
	    value += obj[ prop ];
	  }
	  return value;
	}
	
	
	
	$('#client-animated-grid-four').gridrotator( {
		rows		: 1,
		columns		: 4,
		animType	: 'fadeInOut',
		animSpeed	: 500,
		interval	: 2000,
		step		: 1,
		w1024			: {
			rows	: 1,
			columns	: 4
		},
		
		w768			: {
			rows	: 1,
			columns	: 4
		},
		
		w480			: {
			rows	: 2,
			columns	: 2
		},
		
		w320			: {
			rows	: 2,
			columns	: 2
		},
		
		w240			: {
			rows	: 2,
			columns	: 2
		},
		preventClick	: true
	} );
	$('#client-animated-grid-eight').gridrotator( {
		rows		: 2,
		columns		: 4,
		animType	: 'fadeInOut',
		animSpeed	: 500,
		interval	: 2000,
		step		: 1,
		w1024			: {
			rows	: 2,
			columns	: 4
		},
		
		w768			: {
			rows	: 2,
			columns	: 4
		},
		
		w480			: {
			rows	: 4,
			columns	: 2
		},
		
		w320			: {
			rows	: 4,
			columns	: 2
		},
		
		w240			: {
			rows	: 4,
			columns	: 2
		},
		preventClick	: true
	} );
	$('#client-animated-grid-twelve').gridrotator( {
		rows		: 3,
		columns		: 4,
		animType	: 'fadeInOut',
		animSpeed	: 500,
		interval	: 2000,
		step		: 2,
		w1024			: {
			rows	: 3,
			columns	: 4
		},
		
		w768			: {
			rows	: 4,
			columns	: 3
		},
		
		w480			: {
			rows	: 6,
			columns	: 2
		},
		
		w320			: {
			rows	: 6,
			columns	: 2
		},
		
		w240			: {
			rows	: 6,
			columns	: 2
		},
		preventClick	: true
	} );
	$('#client-animated-grid-sixteen').gridrotator( {
		rows		: 4,
		columns		: 4,
		animType	: 'fadeInOut',
		animSpeed	: 500,
		interval	: 2000,
		step		: 2,
		w1024			: {
			rows	: 4,
			columns	: 4
		},
		
		w768			: {
			rows	: 4,
			columns	: 4
		},
		
		w480			: {
			rows	: 8,
			columns	: 2
		},
		
		w320			: {
			rows	: 8,
			columns	: 2
		},
		
		w240			: {
			rows	: 8,
			columns	: 2
		},
		preventClick	: true
	} );
	$('#client-animated-grid-eighteen').gridrotator( {
		rows		: 3,
		columns		: 6,
		animType	: 'fadeInOut',
		animSpeed	: 500,
		interval	: 2000,
		step		: 2,
		w1024			: {
			rows	: 3,
			columns	: 5
		},
		
		w768			: {
			rows	: 4,
			columns	: 4
		},
		
		w480			: {
			rows	: 8,
			columns	: 2
		},
		
		w320			: {
			rows	: 8,
			columns	: 2
		},
		
		w240			: {
			rows	: 8,
			columns	: 2
		},
		preventClick	: true
	} );
	
	
})(jQuery);

// Run when page and content are ready
/*$( window ).on( "load", function() {
	
	
});*/